import React from 'react';
import { Target, Users, TrendingUp, Zap } from 'lucide-react';
export function HowWeExecutePage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1112">
      <main className="flex-grow pt-32" data-id="element-1113">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-50 to-white py-16" data-id="element-1114">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-1115">
            <div className="max-w-4xl mx-auto text-center" data-id="element-1116">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-1117">
                How We Execute
              </h1>
              <p className="text-xl text-gray-600" data-id="element-1118">
                At SkillzHQ, we are committed to supporting African businesses
                by integrating culture transformation with strategic execution.
                Our approach is designed to drive sustainable success, empower
                individuals, and foster innovation.
              </p>
            </div>
          </div>
        </section>

        {/* Execution Philosophy */}
        <section className="py-16 bg-white" data-id="element-1119">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-1120">
            <div className="max-w-4xl mx-auto" data-id="element-1121">
              <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1122">
                Our Execution Philosophy
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1123">
                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-1124">
                  <div className="flex items-center mb-4" data-id="element-1125">
                    <Target className="h-8 w-8 text-blue-600 mr-3" data-id="element-1126" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-1127">
                      Needs Based Approach
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-1128">
                    We offer bespoke services to high growth organisations,
                    supporting their long-term visions.
                  </p>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-1129">
                  <div className="flex items-center mb-4" data-id="element-1130">
                    <Users className="h-8 w-8 text-blue-600 mr-3" data-id="element-1131" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-1132">
                      Tailored Programs
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-1133">
                    We understand that every organization is unique. Our
                    programs are customized to fit the specific needs of your
                    business.
                  </p>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-1134">
                  <div className="flex items-center mb-4" data-id="element-1135">
                    <TrendingUp className="h-8 w-8 text-blue-600 mr-3" data-id="element-1136" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-1137">
                      Expert-Driven Approach
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-1138">
                    Our team consists of seasoned professionals with deep
                    expertise in leadership, culture transformation, and
                    organizational strategy.
                  </p>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-1139">
                  <div className="flex items-center mb-4" data-id="element-1140">
                    <Zap className="h-8 w-8 text-blue-600 mr-3" data-id="element-1141" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-1142">
                      Sustainable Growth Focus
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-1143">
                    We ensure that everything we do supports long-term success,
                    building strong foundations for the future.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose SkillzHQ */}
        <section className="py-16 bg-gray-50" data-id="element-1144">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-1145">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1146">
              Why Choose SkillzHQ?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto" data-id="element-1147">
              <div className="text-center" data-id="element-1148">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1149">
                  <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1150">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1151" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-1152">
                  Expert-Driven Solutions
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1153">
                  Our programs are led by industry experts with proven track
                  records in leadership, culture, and strategy.
                </p>
              </div>
              <div className="text-center" data-id="element-1154">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1155">
                  <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1156">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" data-id="element-1157" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-1158">
                  Customized Approach
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1159">
                  We tailor every solution to meet your unique challenges and
                  goals.
                </p>
              </div>
              <div className="text-center" data-id="element-1160">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1161">
                  <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1162">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" data-id="element-1163" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-1164">
                  Measurable Impact
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1165">
                  We prioritize results, ensuring our strategies deliver
                  tangible and lasting improvements.
                </p>
              </div>
              <div className="text-center" data-id="element-1166">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1167">
                  <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1168">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-1169" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-1170">
                  Flexible Delivery
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1171">
                  From in-person workshops to online programs, we adapt to your
                  team's needs.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>;
}